
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Vocal</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Vidushi Aarti Ankalikar - Tikekar <span >Hindustani Classical Vocalist </span></h2>
            </div>

            <div class="row">
                <div class="col-lg-7">
                    <p class="text-justify">Born on 27th January 1963 in Bijapur, Karnataka, Aarti Ankalikar Tikekar is
                        currently recognized as one of the top vocalists of the younger generation. She started her
                        training with veteran Late Pandit Vasantrao Kulkarni and pt. Dinkar Kaikini of the Agra Gwalior
                        gharanas. Thereafter she was fortunate in receiving training from Ganasaraswati Vidushi Kishori
                        Amonkar of the Jaipur Atrauli gharana.
                    </p>
                    <p class="text-justify">Listening to her performances one sees a very pleasant blend of the various
                        gharanas represented by her teachers. Endowed with a rich resonant voice, Aarti's performances
                        are marked by an excellent command over both the rhythm and the melody.</p>
                    <p class="text-justify">She has performed at many prestigious conferences in India, such as the
                        Sawai Gandharva Mahotsav (Pune), the Malhar Utsav (Delhi), Tansen Samaroh (Gwalior), the Dover
                        Lane Festival (Kolkotta), the Shankarlal Festival (Delhi) and at sabhas organized by the Madras
                        Music Academy (Chennai). She has also performed in Bangalore, Jaipur, Jodhpur, Ajmer, Udaypur,
                        Agra, Banaras (Ganga Utsav), Bhubneshwar, almost all major cities in Maharashtra, Karnataka,
                        M.P., Rajasthan, Tamilnadu and Kerala. She has been on concert tours in USA, Canada, UK and UAE,
                        Australia, Singapore, Malaysia and many other countries. She takes efforts to promote Indian
                        Classical Music and Culture in different parts of the World.</p>
                    <p class="text-justify"></p>
                    <p class="text-justify"></p>
                    <p class="text-justify"></p>
                    <p class="text-justify"></p>
                </div>
                <div class="col-md-5">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/aarti_ankalikar.webp"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
                <div class="col-md-12">
                    <p class="text-justify"> A recipient of a Central Government scholarship (1975-80) and the Surashri
                        Kesarbai Kerkar scholarship (1980-82), Aarti stood first in the All India Radio competition held
                        during 1983 and 1984 in Indian classical music, thumri and gazal and was awarded gold medal in
                        all the three categories. She has received Mayor Award (2001)and prestigious Pt.Kumar Gandharva
                        Sanman (2006-07) (M.P.) She also has been awarded Pt. Jasraj Award.</p>
                    <p class="text-justify"> Aarti has to her credit a number of audio cassettes and CD recordings. She
                        was the main playback singer for the Sham Benegal's film, "Sardari Begum."

                    </p>
                    <p class="text-justify"> She is receipent of Sangeet Natak Akademy Award in 2020.

                    </p>
                    <p class="text-justify"> She has received National Award (best playback singer) for the Konkani film
                        'Anternaad',based on the life of a classical singer for the year 2006. She has also received
                        Maharashtra State Award (best playback singer) , V. Shantaram Award and Maharashtra Times Award
                        .She has sung in films like Sawali,Antarnad,De Dhakka, Samhita etc .
                    </p>

                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Performer: Vidushi Aarti Ankalikar (Indian Classical Vocalist) </b></p>
                    <p><b>Date – 9<sup>th </sup> September 2023 </b></p>
                    <!-- <p><b>Time – 5:00 pm - Sharp (Grab your seats before time)</b></p> -->
                    <p><b>Venue: Sai Sabhagruha 12, Near Wockhardt Hospital, Ambazari Rd, Shivaji Nagar, Nagpur-10 </b>
                    </p>
                    <!-- <a class="btn button--effect-2 mx-2 btn-color"
                        href="https://www.ghrscf.com/registration-ankalikar">Register Now for Free</a> -->
                </div>

            </div>
        </div>



    </div>
</section>

<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <!-- <div class="col">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Media Coverage</h4>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div> -->
            <div class="col">

                <div class="gall-ery">
                    <div class="row justify-content-between">
                        <div class="col-md-7">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-5 text-end">
                            <a href="photogallery#vidushi " target="_blank" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
